export type SortValue = string | number | null

export type SortDirection = "asc" | "desc"

function compare(a: string | number, b: string | number): number {
  if (typeof a === "number" && typeof b === "number") return a - b
  return String(a).localeCompare(String(b), undefined, { numeric: true })
}

export function sortRows<R>(
  rows: R[],
  keyOf: (row: R) => SortValue,
  direction: SortDirection,
): R[] {
  const sign = direction === "asc" ? 1 : -1
  return [...rows].sort((left, right) => {
    const a = keyOf(left)
    const b = keyOf(right)
    if (a === b) return 0
    if (a === null) return 1
    if (b === null) return -1
    return sign * compare(a, b)
  })
}
